import { Space, Tag, Typography } from 'antd'

import { StatusTag } from '@/Ship/Components/StatusTag'
import { formatDateTimeUk, userName } from '@/Ship/Helpers/fieldViews'

import { ACTIVITY_OVERDUE_LABEL } from '../Contracts/ActivityFieldLabels'
import { isActivityOverdue } from '../Helpers/activityOverdue'

import type { ActivityRecord } from '../Contracts/Activity.types'

import './activity.css'

const dash = <Typography.Text type="secondary">—</Typography.Text>

/**
 * «Статус» у рядку (`SPEC-011` §8.1, Р11): бейдж кольору довідника — той
 * самий `StatusTag`, що в шапці картки, — і червоний тег «Прострочена», якщо
 * справа під предикатом П: простроченість читається словом, а не лише тлом
 * рядка.
 */
export const ActivityStatusTags = ({ record }: { record: ActivityRecord }) => {
    const status = record.status
    const overdue = isActivityOverdue(record)

    if (!status || typeof status.title !== 'string') return overdue ? <Tag color="error">{ACTIVITY_OVERDUE_LABEL}</Tag> : dash

    return (
        <Space size={4} wrap>
            <StatusTag label={status.title} {...(typeof status.color === 'string' ? { color: status.color } : {})} />
            {overdue ? <Tag color="error">{ACTIVITY_OVERDUE_LABEL}</Tag> : null}
        </Space>
    )
}

/** Опис одним рядком із трикрапкою; повний — у підказці (Р8). */
export const ActivityDescription = ({ text }: { text: unknown }) =>
    typeof text === 'string' && text.trim() !== '' ? (
        <span className="wl-activity-description" title={text}>
            {text}
        </span>
    ) : (
        dash
    )

/** «Крайній термін» — «дд.мм.рррр, гг:хх» (Р9). */
export const ActivityDeadline = ({ value }: { value: unknown }) => {
    const text = formatDateTimeUk(value)

    return text === '—' ? dash : <>{text}</>
}

/** «Відповідальний» — коротке ім'я (Р10). */
export const ActivityResponsible = ({ record }: { record: ActivityRecord }) => {
    const user = record.responsible
    const name = user ? userName(user) : ''

    return name !== '' ? <>{name}</> : dash
}

/** Клас червоного рядка: предикат П, а не прапорець воркера (Р12). */
export const activityRowClassName = (record: ActivityRecord): string =>
    isActivityOverdue(record) ? 'wl-activity-overdue' : ''
